import './style.css';

function Loading() {
  return (
    <div className="loading">
      <p>Checking alert conditions...</p>
    </div>
  );
}

export default Loading;
